/* Shop's "Sign in with Shop" opens a 365px windoid. Popup blockers and
   Safari leave the purple button spinning. Send that login to this tab. */
(function () {
  if (window.__belnayShopLogin) return;
  window.__belnayShopLogin = true;
  var nativeOpen = window.open;
  window.open = function (url, target, features) {
    try {
      var href = String(url == null ? "" : url);
      var shopWindoid =
        href.indexOf("shop.app/accounts/login") !== -1 ||
        (href.indexOf("customer_authentication/login") !== -1 &&
          (href.indexOf("ux_mode=windoid") !== -1 || href.indexOf("display=popup") !== -1));
      if (shopWindoid) {
        window.location.assign(
          href.replace("ux_mode=windoid", "ux_mode=redirect").replace("display=popup", "display=page")
        );
        return window;
      }
    } catch (err) {}
    return nativeOpen.apply(this, arguments);
  };
})();
